import React from "react";
import styles from './TextAreaInput.styl';

function TextAreaInput(props) {

	const {x, y, title, width, rows = 4, ...addProps} = props
	return (
		<div>
			<span className={styles.selectLabel} style={{top: y + 'px', left: x + 'px'}}>{title}</span>
			<textarea
						className={styles.selectBase}
						style={{top: y + 17 + 'px', left: x + 'px', width: width ? width + 'px' : '140px', height: rows ? (rows * 25) + 'px': '100px' }}
						rows={rows}
						{...addProps}
					/>
		</div>
	)

}

export default TextAreaInput;



// WEBPACK FOOTER //
// ./src/react/ui/features/TextArea/TextAreaInput.jsx